"use client";

import { MultiStepForm } from './components/MultiStepForm';
import { McDonaldsProgramFormConfig } from './McDonaldsProgramFormConfig';

export function McDonaldsProgramForm() {
  return (
    <MultiStepForm 
      config={McDonaldsProgramFormConfig}
      className="mcdonalds-program-form"
    />
  );
} 